import { render, staticRenderFns } from "./supplierInfo.vue?vue&type=template&id=02a98cde&scoped=true"
import script from "./supplierInfo.vue?vue&type=script&lang=js"
export * from "./supplierInfo.vue?vue&type=script&lang=js"
import style0 from "./supplierInfo.vue?vue&type=style&index=0&id=02a98cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a98cde",
  null
  
)

export default component.exports